import { endOfDay, isWithinInterval, startOfDay } from "date-fns";
import Cookies from "js-cookie";
import { ref } from "vue";

export const useTourCookie = (steps: { avatar_image: boolean; personal_data: boolean; professional_data: boolean }) => {
  const showTour = ref(true);

  const tourCompleted = steps.avatar_image && steps.personal_data && steps.professional_data;
  const tourHideCookieIsSet = Cookies.get("tourHidden") === "true";

  if (tourCompleted || tourHideCookieIsSet) showTour.value = false;

  const hideTour = () => {
    showTour.value = false;

    // hide tour for 14 days (* 1000 bc millisec)
    const date = new Date(Date.now() + 14 * 24 * 3600 * 1000);
    Cookies.set("tourHidden", "true", { expires: date, path: "/" });
  };

  return { showTour, hideTour };
};

export const useGreeting = () => {
  const currentYear = () => new Date().getFullYear();

  const isChristmas = (): boolean =>
    isWithinInterval(new Date(), {
      start: startOfDay(new Date(`${currentYear()}-12-24`)),
      end: endOfDay(new Date(`${currentYear()}-12-26`)),
    });

  const isBetweenYears = (): boolean =>
    isWithinInterval(new Date(), {
      start: startOfDay(new Date(`${currentYear()}-12-27`)),
      end: endOfDay(new Date(`${currentYear()}-12-31`)),
    });

  const isNewYear = (): boolean =>
    isWithinInterval(new Date(), {
      start: startOfDay(new Date(`${currentYear()}-01-01`)),
      end: endOfDay(new Date(`${currentYear()}-01-06`)),
    });

  const getSeason = () => {
    const seasons = [
      { key: "christmas", predicate: isChristmas },
      { key: "between_years", predicate: isBetweenYears },
      { key: "new_year", predicate: isNewYear },
    ];
    const { key } = seasons.find(({ predicate }) => predicate()) || { key: "normal" };

    return key;
  };

  return `start.index.logged_in_banner.greeting.${getSeason()}`;
};
